import { css } from '@inter-ikea-kompis/web-component';
const MIN_HEIGHT = 88;
/**
 * A class with style.
 */
export default class AccordionItemStyle {
    /**
     * Returns styles.
     *
     * @param options The props.
     * @param options.showOutline Show outline.
     * @param options.expanded Open state.
     * @param options.accordionLayout Layout state.
     * @param options.theme Theme.
     * @param options.disabled ...
     * @returns Styles.
     */
    static getStyle(options) {
        const { color, spacing, focusOutline, motion } = options.theme;
        return css `
			:host {
				display: block;
				border-width: ${1 / 16}rem;
				border-top-style: solid;
				border-color: ${options.disabled ? color.disabled.default : color.border.light};
			}
			:host(:last-of-type) {
				border-bottom-style: solid;
			}
			button {
				/* Disable user agent styling */
				background: none;
				outline: none;
				border: none;
				box-shadow: none;
				position: relative;
				text-align: initial;
				width: 100%;
				padding: ${spacing.space150 / 16}rem ${this.getPadding(options) / 16}rem;
				min-height: ${MIN_HEIGHT / 16}rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				color: ${options.disabled ? color.disabled.default : color.text.dark};
			}
			button::-moz-focus-inner {
				border: 0;
			}
			.outline {
				position: absolute;
				pointer-events: none;
				opacity: 0;
				transition-duration: ${focusOutline.transitionTime}s;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				transition-property: opacity, top, left, right, bottom;
				border-radius: ${focusOutline.borderRadius}px;
				box-shadow: 0 0 0 ${focusOutline.width}px ${focusOutline.color};
			}
			button:focus-visible .outline {
				opacity: 1;
				top: -${focusOutline.offset / 16}rem;
				left: -${focusOutline.offset / 16}rem;
				right: -${focusOutline.offset / 16}rem;
				bottom: -${focusOutline.offset / 16}rem;
			}
			button:hover {
				cursor: ${options.disabled ? 'initial' : 'pointer'};
			}
			@media (pointer: fine) {
				button:hover .header {
					text-decoration: ${options.disabled ? 'inital' : 'underline'};
				}
			}
			.textContainer {
				display: flex;
				flex-direction: column;
			}
			.spacing {
				width: ${spacing.space50 / 16}rem;
				flex-shrink: 0;
			}
			.icon {
				transform: rotate(${options.expanded ? '180deg' : '0deg'});
				transition: transform ${motion.duration.medium} ${motion.ease.easy};
				transition-duration: ${motion.duration.medium};
				color: ${options.disabled ? color.disabled.default : color.icon.default};
			}
			::slotted(kompis-accordion-item-padding) {
				display: block;
				padding: ${spacing.space150 / 16}rem ${this.getPadding(options) / 16}rem;
			}
			${this.getRtlRules(options)}
		`;
    }
    /**
     * Returns styles.
     *
     * @param options The props.
     * @param options.accordionLayout Layout state.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getPadding(options) {
        if (options.noHorizontalPadding) {
            return 0;
        }
        return options.theme.spacing.space150;
    }
    /**
     * Returns styles.
     *
     * @param options The props.
     * @param options.accordionLayout Layout state.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getRtlRules(options) {
        if (!options.expanded) {
            return css ``;
        }
        // I don't think these are needed. The icon is vertically symmetrical and the the selectors do not cover all browsers.
        return css `
			:host(:dir(rtl)) .icon {
				transform: rotate(-180deg);
			}
			:host-context([dir='rtl']) .icon {
				transform: rotate(-180deg);
			}
		`;
    }
}
//# sourceMappingURL=AccordionItemStyle.js.map